<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="tituloCard" *ngIf="!mostrarFormulario" [optionsExport]="false">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <h2 class="container float-left">{{ tituloForm }}</h2>
  <div class="row form-group">
    <div class="form-group col-md-5" style="display: flex;justify-content: start;align-items: center;">
      <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
        (keyup)="onQuickFilterChanged() " #quickFilter />
    </div>
    <div class="form-group col-12 col-md-3">
      <div [formGroup]="formularioFiltroTipoDeVendedores" novalidate class="form-group">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
          [comboBox]="listTiposDeVendedores" [label]="'Tipo de Vendedor *'" formControlName="idTipoVendedor"
          [control]="formularioFiltroTipoDeVendedores.get('idTipoVendedor')" [id]="'idTipoVendedor'">
        </app-lfsa-combo-box>
      </div>
    </div>
    <!-- <div class="form-group col-md-2" style="display: flex;justify-content: start;align-items: center;">
      <button (click)="nuevo()" class={{DAT_BTNCSS.success}}>{{DAT_BTNS.agregar}}</button>
    </div> -->
    <div class="form-group col-md-2" style="display: flex;justify-content: start;align-items: center;">
      <button (click)="descargarExcel()" class={{DAT_BTNCSS.success}}>Descargar</button>
    </div>
    <div class="form-group col-md-2" style="display: flex;justify-content: start;align-items: center;">
      <a href="comisiones/asignacion-y-distribucion-csv" style="width: 100%;">
        <button class={{DAT_BTNCSS.success}}>Cargar</button>
      </a>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12">
      <ag-grid-angular class="{{modulo.agGrid.class}}" #agGrid [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
        [paginationPageSize]="modulo.agGrid.paginacion" [pagination]="true" [frameworkComponents]="frameworkComponents"
        [columnDefs]="columnDefs" [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>


<app-lfsa-card [innTemplate]="enviarTemplateResport" [titulo]="tituloForm" *ngIf="mostrarFormulario">
</app-lfsa-card>
<ng-template #enviarTemplateResport>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'date'" [class]="'letrasDanger'" [placeholder]="'Ingrese Fecha Inicio'"
          [label]="'Fecha Inicio *'" [id]="'fechaInicio'" formControlName="fechaInicio"
          [control]="formulario.get('fechaInicio')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-6">
        <app-lfsa-input [type]="'date'" [class]="'letrasDanger'" [placeholder]="'Ingrese Fecha Fin'"
          [label]="'Fecha Fin *'" [id]="'fechaFin'" formControlName="fechaFin"
          [control]="formulario.get('fechaFin')"></app-lfsa-input>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idTipo'"
          [comboBox]="listTiposDeVendedores" formControlName="tipoVendedorId"
          [control]="formulario.get('tipoVendedorId')" [label]="'Tipo de Vendedor *'" [id]="'tipoVendedorId'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'descripcion'" [idOpcion]="'idVariable'"
          [comboBox]="listTiposDeVariables" formControlName="variableId" [control]="formulario.get('variableId')"
          [label]="'Seleccione Variable *'" [id]="'variableId'">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-12 col-md-4">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Ingrese Valor Peso'"
          [label]="'Valor Peso *'" [id]="'valorPeso'" formControlName="valorPeso"
          [control]="formulario.get('valorPeso')"></app-lfsa-input>
      </div>
    </div>
  </div>
  <div class="row">
    <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones( $event )"
      [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </div>
</ng-template>
